import { useNavigate, useLocation } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id: string) => {
    // Si on n'est pas sur la page d'accueil, naviguer d'abord vers l'accueil
    if (location.pathname !== '/') {
      navigate('/');
      // Attendre que la navigation soit terminée avant de scroller
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const navHeight = 80;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Si on est déjà sur la page d'accueil, scroller directement
      const element = document.getElementById(id);
      if (element) {
        const navHeight = 80;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - navHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return (
    <footer className="relative bg-black text-white py-12 sm:py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-12 sm:mb-16">
          <div>
            <button
              onClick={handleLogoClick}
              className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6 cursor-pointer"
            >
              <img
                src="https://static.readdy.ai/image/a16a140b1ca96878839a6d35b91aba7d/90e6c0507c04b23ac45764b988f5600d.png"
                alt="OTOROBOTS"
                className="h-10 sm:h-12 w-auto"
              />
              <div className="w-px h-8 sm:h-10 bg-white"></div>
              <div className="text-xs sm:text-sm font-light tracking-wide text-white text-left">
                OTOROBOTS<br />CANADA INC.
              </div>
            </button>
            <div className="space-y-2 text-sm text-gray-300 font-light">
              <p>Structure canadienne</p>
              <p>Technologie au service de l'humain</p>
              <p>Gouvernance responsable</p>
            </div>
          </div>

          <div>
            <h3 className="text-xs tracking-widest text-gray-400 uppercase mb-4 sm:mb-6">Navigation</h3>
            <div className="space-y-3">
              <button
                onClick={() => scrollToSection('qui-sommes-nous')}
                className="block text-sm text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Qui sommes-nous
              </button>
              <button
                onClick={() => scrollToSection('raison-etre')}
                className="block text-sm text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Raison d'être
              </button>
              <button
                onClick={() => scrollToSection('valeurs')}
                className="block text-sm text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Valeurs
              </button>
              <button
                onClick={() => scrollToSection('gouvernance')}
                className="block text-sm text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Gouvernance
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-xs tracking-widest text-gray-400 uppercase mb-4 sm:mb-6">Légal</h3>
            <div className="space-y-3">
              <a href="/mentions-legales" className="block text-sm text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Mentions légales
              </a>
              <a href="/politique-confidentialite" className="block text-sm text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Confidentialité
              </a>
              <a href="/conditions-utilisation" className="block text-sm text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Conditions d'utilisation
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xs tracking-widest text-gray-400 uppercase mb-4 sm:mb-6">Contact</h3>
            <p className="text-sm text-white/90 font-light leading-relaxed mb-4">
              Pour toute question concernant OTOROBOTS CANADA INC. et notre vision.
            </p>
            <a 
              href="mailto:info@otorobots.com"
              className="text-sm text-white hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap block mb-3"
            >
              info@otorobots.com
            </a>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm text-white underline hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              Nous contacter
            </button>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 sm:pt-12">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
            <div className="text-sm text-gray-400 font-light text-center sm:text-left">
              <p className="mb-2">© 2026 OTOROBOTS CANADA INC. Tous droits réservés.</p>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
